import { main, registerComponents } from '@eastsideco/salvo-ts';
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const swiper = new Swiper('.swiper-container', {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
});

const swiperContainer = document.querySelector('.swiper-container');

if (swiperContainer) {
    swiperContainer.addEventListener('mouseleave', () => {
        swiper.autoplay.start();
    });
}


// Register components with SALVO-TS
registerComponents(require.context('./components/', true), process.env.SALVO_BUILD_VARIANT);

// Initialize theme
export const theme = main({
    enableLegacySalvoLiteComponentSupport: true,
});
